import { ReactNode } from 'react';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';

import { ModalDrawer } from '@ocx/ui-modals';

import { referAFriendMessages } from './refer-a-friend.messages';

export type ReferAFriendLayoutProps = {
  children: ReactNode;
  isOpen: boolean;
  onClose(): void;
  onExited(): void;
};

export const ReferAFriendLayout = (props: ReferAFriendLayoutProps) => {
  const { children, isOpen, onClose, onExited } = props;
  return (
    <ModalDrawer open={isOpen} onClose={onClose} onExited={onExited}>
      <HtmlTitle title={referAFriendMessages.htmlTitle} />
      {children}
    </ModalDrawer>
  );
};
